<template>
  <div>
    <div class="section content">
      <div class="columns is-centered">
        <div class="column is-11">
          <div class="columns">
            <div class="column has-text-centered">
              <h2 class="title is-2">
                Password Update
              </h2>
              <div class="subtitle is-2">
                Please enter your current password, and the new password twice. The password must be at least 12 characters long and contain the following: upper case (A-Z), lower case (a-z), number (0-9) and special character (e.g. !@#$%^&*).
              </div>
            </div>
          </div>
          <validation-observer
            ref="form-password-update"
            tag="form"
          >
            <div class="columns">
              <div class="column is-one-third">
                <textbox-vee
                  id="password-current"
                  v-model="password"
                  type="password"
                  placeholder="Current Password"
                  rules="required|phlpass"
                  autocomplete="off"
                  required
                />
              </div>
              <div class="column is-one-third">
                <textbox-vee
                  id="password-new"
                  v-model="newPassword"
                  type="password"
                  placeholder="New Password"
                  rules="required|phlpass"
                  autocomplete="off"
                  required
                  vid="password-new"
                />
              </div>
              <div class="column is-one-third">
                <textbox-vee
                  id="password-confirm"
                  v-model="newPasswordRepeat"
                  type="password"
                  rules="required|confirmed:password-new"
                  placeholder="Repeat New Password"
                  autocomplete="off"
                  required
                />
              </div>
            </div>
            <div class="columns">
              <div class="column has-text-centered">
                <button
                  id="update-password-btn"
                  type="button"
                  class="button is-secondary"
                  :class="isUpdating ? 'is-loading' : ''"
                  :disabled="isUpdating"
                  @click="updatePassword"
                >
                  Update Password
                </button>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { controlValueHelpers } from '@/mixins/controlValue';
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { Textbox } from '@phila/phila-ui';
import { withValidation } from 'vee-validate';

const TextboxVee = withValidation(Textbox);

export default {
  name: 'UpdatePassword',
  components: {
    TextboxVee,
  },
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  data() {
    return {
      isUpdating: false,
      password: '',
      newPassword: '',
      newPasswordRepeat: '',
    };
  },
  methods: {
    resetPasswordFields () {
      this.password = '';
      this.newPassword = '';
      this.newPasswordRepeat = '';
    },
    async updatePassword () {

      let isValid = await this.$refs['form-password-update'].validate();

      if (!isValid) {
        this.$warning("There are some validation issues. Please review form below and try again");
        return false;
      }

      this.isUpdating = true;

      let passwords = {
        password: this.password,
        newPassword: this.newPassword,
      };

      this.$store.dispatch('user/updateUserPassword', passwords).then(() => {
        this.isUpdating = false;
        this.$refs['form-password-update'].reset();
        this.resetPasswordFields();
        this.$success(`Your password has been updated.`);
      }).catch(error => {
        this.isUpdating = false;
        this.$refs['form-password-update'].reset();
        this.resetPasswordFields();
        this.$warning(`There was an issue updating your password. Make sure your password follow the indicated requirements below.`);
        console.warn(error);
      });
    },
  },
};
</script>